import Swiper from 'swiper';
import { Navigation, FreeMode, Mousewheel, Scrollbar } from 'swiper/modules';

const Teams = ( $ ) => {
	$( '.team-items' ).each( function() {
		const $this = $( this );
		new Swiper(
			this,
			{
				slidesPerView: 'auto',
				modules: [ Navigation, FreeMode, Mousewheel, Scrollbar ],
				navigation: {
					nextEl: $this.find( '.swiper-button-next' )[ 0 ],
					prevEl: $this.find( '.swiper-button-prev' )[ 0 ],
				},
				freeMode: {
					enabled: true,
					sticky: true,
				},
				mousewheel: {
					invert: true,
				},
				scrollbar: {
					el: $this.find( '.swiper-scrollbar' )[ 0 ],
					hide: true,
				},
			}
		);
	} );
};

export default ( ( $ ) => $( Teams ) )( jQuery );
